import {VetineoConfigurationError} from "./vetineo-configuration-error.model";

/**
 * Model odpowiedzi z narzędzia diagnostycznego.
 * Raportuje stan zdrowia systemu, dzieląc wykryte nieprawidłowości na trzy
 * główne obszary infrastruktury.
 */
export class CheckVetineoConfigurationResponse {

  /**
   * Lista błędów w głównej warstwie aplikacji Vetineo.
   */
  public vetineo: VetineoConfigurationError[];

  /**
   * Lista błędów konfiguracyjnych w warstwie Sitesbi.
   */
  public sitesbi: VetineoConfigurationError[];

  /**
   * Lista błędów warstwy danych (MSQL - Database Layer).
   */
  public msql: VetineoConfigurationError[];

}
